import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function submitInquiry(payload) {
  const { data } = await axios.post(`${API}/inquiries`, payload);
  return data;
}

// Auth
export async function apiRegister(payload) {
  const { data } = await axios.post(`${API}/auth/register`, payload, cfg);
  return data;
}
export async function apiLogin(payload) {
  const { data } = await axios.post(`${API}/auth/login`, payload, cfg);
  return data;
}
export async function apiGoogleSession(sessionId) {
  const { data } = await axios.post(`${API}/auth/session`, {}, { ...cfg, headers: { "X-Session-ID": sessionId } });
  return data;
}
export async function apiMe() {
  const { data } = await axios.get(`${API}/auth/me`, cfg);
  return data;
}
export async function apiLogout() {
  const { data } = await axios.post(`${API}/auth/logout`, {}, cfg);
  return data;
}

// AI
export async function apiAuditPrep(payload) {
  const { data } = await axios.post(`${API}/ai/audit-prep`, payload, cfg);
  return data;
}
export async function apiListAuditPreps() {
  const { data } = await axios.get(`${API}/ai/audit-prep`, cfg);
  return data;
}
export async function apiGapAnalysis(payload) {
  const { data } = await axios.post(`${API}/ai/gap-analysis`, payload, cfg);
  return data;
}
export async function apiListGapAnalyses() {
  const { data } = await axios.get(`${API}/ai/gap-analysis`, cfg);
  return data;
}
export async function apiDocGen(payload) {
  const { data } = await axios.post(`${API}/ai/document-generator`, payload, cfg);
  return data;
}
export async function apiListDocGen() {
  const { data } = await axios.get(`${API}/ai/document-generator`, cfg);
  return data;
}
export async function apiCapa(payload) {
  const { data } = await axios.post(`${API}/ai/corrective-action`, payload, cfg);
  return data;
}
export async function apiListCapa() {
  const { data } = await axios.get(`${API}/ai/corrective-action`, cfg);
  return data;
}
export async function apiRiskScoring(payload) {
  const { data } = await axios.post(`${API}/ai/risk-scoring`, payload, cfg);
  return data;
}
export async function apiListRiskScoring() {
  const { data } = await axios.get(`${API}/ai/risk-scoring`, cfg);
  return data;
}
export async function apiTraining(payload) {
  const { data } = await axios.post(`${API}/ai/training-competency`, payload, cfg);
  return data;
}
export async function apiListTraining() {
  const { data } = await axios.get(`${API}/ai/training-competency`, cfg);
  return data;
}
export async function apiSafetyAnalyzer(payload) {
  const { data } = await axios.post(`${API}/ai/safety-analyzer`, payload, cfg);
  return data;
}
export async function apiListSafetyAnalyses() {
  const { data } = await axios.get(`${API}/ai/safety-analyzer`, cfg);
  return data;
}

// Workspace (team)
export async function apiGetOrg() {
  const { data } = await axios.get(`${API}/org`, cfg);
  return data;
}
export async function apiInviteMember(payload) {
  const { data } = await axios.post(`${API}/org/invite`, { ...payload, origin_url: window.location.origin }, cfg);
  return data;
}
export async function apiAcceptInvite(token) {
  const { data } = await axios.post(`${API}/org/accept`, { token }, cfg);
  return data;
}

// Developer API keys
export async function apiCreateKey(name) {
  const { data } = await axios.post(`${API}/developers/keys`, { name }, cfg);
  return data;
}
export async function apiListKeys() {
  const { data } = await axios.get(`${API}/developers/keys`, cfg);
  return data;
}
export async function apiRevokeKey(keyId) {
  const { data } = await axios.post(`${API}/developers/keys/${keyId}/revoke`, {}, cfg);
  return data;
}

// Billing
export async function apiBillingPlans() {
  const { data } = await axios.get(`${API}/billing/plans`);
  return data;
}
export async function apiBillingMe() {
  const { data } = await axios.get(`${API}/billing/me`, cfg);
  return data;
}
export async function apiBillingCheckout(plan_id) {
  const { data } = await axios.post(`${API}/billing/checkout`, { plan_id, origin_url: window.location.origin }, cfg);
  return data;
}
export async function apiBillingStatus(sessionId) {
  const { data } = await axios.get(`${API}/billing/status/${sessionId}`, cfg);
  return data;
}

// Admin
export async function apiAdminStats() {
  const { data } = await axios.get(`${API}/admin/stats`, cfg);
  return data;
}
export async function apiAdminUsers() {
  const { data } = await axios.get(`${API}/admin/users`, cfg);
  return data;
}
export async function apiAdminInquiries() {
  const { data } = await axios.get(`${API}/inquiries`, cfg);
  return data;
}
export async function apiAdminAuditPreps() {
  const { data } = await axios.get(`${API}/admin/audit-preps`, cfg);
  return data;
}
